import { createProductExtensions } from './utils';
export { Editions } from './types';
export var adminHubExtensionsWhitelist = ['edition', 'migrationSourceUuid', 'grantAccessTo'];
export var createAdminHubExtensions = createProductExtensions(adminHubExtensionsWhitelist);